// Image click zoom and drag to pan
const ZOOM = 2.6;
const DRAG_SPEED = 3;
const INIT_EVENTS = ['DOMContentLoaded', 'shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder'];

function initZoom() {
  // swiper instance
  const swiperEl = document.querySelector('.bz_zoomed .swiperMainProduct');
  const swiper = swiperEl ? swiperEl.swiper : null;

  document.querySelectorAll(".swiperMainProduct .zoom_wrap").forEach(container => {
    // section events re-run this, so bind each container only once
    if (container.dataset.zoomReady) return;
    container.dataset.zoomReady = 'true';

    const img = container.querySelector(".swiperMainProduct img");
    if (!img) return;

    let scale = 1;
    let zoomed = false;
    let posX = 0;
    let posY = 0;
    let startX = 0;
    let startY = 0;
    let isPointerDown = false;
    let moved = false;

    container.addEventListener("click", (e) => {
      // a drag ends with a click, so ignore it
      if (moved) { moved = false; return; }
      if (!zoomed) {
        // wait until the image has its size, otherwise the zoom math gives NaN
        if (!img.naturalWidth) return;

        const rect = container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        scale = ZOOM;
        zoomed = true;
        img.style.cursor = "zoom-out";

        // disable swiper when zoomed
        if (swiper) swiper.allowTouchMove = false;

        const { dispW, dispH } = getDisplaySize();
        posX = -((x / rect.width * dispW * scale) - x);
        posY = -((y / rect.height * dispH * scale) - y);

        limit();
        render();
      } else {
        reset();
      }
    });

    img.addEventListener("pointerdown", (e) => {
      if (!zoomed) return;
      isPointerDown = true;
      moved = false;
      // stop swiper drag
      if (swiper) swiper.allowTouchMove = false;

      img.setPointerCapture(e.pointerId);
      startX = e.clientX - posX / DRAG_SPEED;
      startY = e.clientY - posY / DRAG_SPEED;
    });
    img.addEventListener("pointermove", (e) => {
      if (!isPointerDown) return;
      moved = true;
      posX = (e.clientX - startX) * DRAG_SPEED;
      posY = (e.clientY - startY) * DRAG_SPEED;
      limit();
      render();
    });

    img.addEventListener("pointerup", (e) => {
      isPointerDown = false;
      img.releasePointerCapture(e.pointerId);
    });
    img.addEventListener("pointercancel", () => {
      isPointerDown = false;
    });

    function reset() {
      scale = 1;
      zoomed = false;
      posX = 0;
      posY = 0;
      img.style.cursor = "zoom-in";

      // re-enable swiper
      if (swiper) swiper.allowTouchMove = true;
      render();
    }

    function getDisplaySize() {
      const imgRatio = img.naturalWidth / img.naturalHeight;
      const containerRatio = container.clientWidth / container.clientHeight;
      let dispW, dispH;

      if (imgRatio > containerRatio) {
        dispW = container.clientWidth;
        dispH = container.clientWidth / imgRatio;
      } else {
        dispH = container.clientHeight;
        dispW = container.clientHeight * imgRatio;
      }
      return { dispW, dispH };
    }

    function limit() {
      const { dispW, dispH } = getDisplaySize();
      const zoomW = dispW * scale;
      const zoomH = dispH * scale;

      posX = Math.min(0, Math.max(posX, container.clientWidth - zoomW));
      posY = Math.min(0, Math.max(posY, container.clientHeight - zoomH));
    }
    function render() {
      img.style.transform = `translate(${posX}px, ${posY}px) scale(${scale})`;
    }
  });
}

INIT_EVENTS.forEach(event => { document.addEventListener(event, initZoom); });

